import { OPEN_VERIFY_PAGE } from './ActionConstants.js'

export function openVerifyPage(data) {
    return { type: OPEN_VERIFY_PAGE, data }
}